import axios, {type AxiosRequestConfig} from 'axios'
import {handleError} from "@/appdata/globals.ts";
import {getAuth} from "@firebase/auth";

export const cookieName = "FB_Authorization";
export const currentAuthToken = () => {
    return (document.cookie
        .split("; ")
        .find((row) => row.startsWith(cookieName +"="))
        ?.split("=")[1]) ?? "";
}

export const api = axios.create({
    baseURL: import.meta.env.VITE_DATA_API || "http://localhost:3000",
    headers: {
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache',
        'Expires': '0',
    }
})

api.interceptors.request.use(async (config: AxiosRequestConfig) => {
    const firebase = getAuth();
    if (firebase.currentUser && !firebase.currentUser.isAnonymous) {
        try {
            const token = await firebase.currentUser.getIdToken();
            config.headers['X-Firebase-Authorization'] = `Bearer ${token}`
        }
        catch (error) {
            handleError(error);
        }
    }
    else {
        const controller = new AbortController();
        controller.abort('Request aborted: user is not authenticated');
        config.signal = controller.signal;
    }

    return config;
})
